import HorizontalScrollMediaView from '../components/HorizontalScrollMediaView';
import HorizontalScrollArtists from '../components/HorizontalScrollArtists';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import MediaGridView from '../components/MediaGridView';
import { getSinglesByArtistId } from '../data/singles';
import { getAlbumsByArtistId } from '../data/albums';
import { getArtistById, getRelatedArtists } from '../data/artists';
import { getStreamsForCurrentMonthByArtistId } from '../data/artistStreamsByMonths';
import Footer from "../components/Footer";
import SectionHeader from '../components/SectionHeader';

const ArtistProfile = () => {

  document.title = "Artist";

  const { artistId } = useParams();
  const artist = getArtistById(Number(artistId));
  const popularSingles = getSinglesByArtistId(Number(artistId));
  const popularAlbums = getAlbumsByArtistId(Number(artistId));
  const relatedArtists = getRelatedArtists(Number(artistId));
  const albums = getAlbumsByArtistId(Number(artistId));
  const singles = getSinglesByArtistId(Number(artistId));
  const currentMonthStreams = getStreamsForCurrentMonthByArtistId(Number(artistId));

  const [searchParams] = useSearchParams();
  const view = searchParams.get('view');

  return (
    <div className="pt-[4rem] mx-2 sm:mx-4 md:mx-8 lg:mx-12 xl:mx-16 2xl:mx-20">
      <div className="flex flex-col items-center text-center mb-8 bg-gradient-to-b from-1% via-20% to-100% from-red-700 via-red-900 to-black py-5">
        <img
          src={artist.image}
          alt={artist.name}
          className="w-48 h-48 md:w-64 md:h-64 object-cover rounded-full mb-4 border border-black"
        />
        <h1 className="text-4xl font-bold mb-2">{artist.name}</h1>
        <p className="text-gray-400">
          {currentMonthStreams?.streams_count} streams this month
        </p>
      </div>
      <div className="flex justify-center gap-4 mb-8">
        <Link to={`/artist/${artist.id}`} className="text-gray-400 hover:text-white">
          Overview
        </Link>
        <Link to={`/artist/${artist.id}?view=all-singles`} className="text-gray-400 hover:text-white">
          All Singles
        </Link>
        <Link to={`/artist/${artist.id}?view=all-albums`} className="text-gray-400 hover:text-white">
          All Albums
        </Link>
      </div>
      {!view ? (
        <>
          <HorizontalScrollMediaView collection={popularSingles} headTitle="Popular Singles" route="single" />
          <HorizontalScrollMediaView collection={popularAlbums} headTitle="Popular Albums" route="album"/>
          <HorizontalScrollArtists artists={relatedArtists} headTitle="Related Artists" />
        </>
      ) : view === 'all-albums' ? (
        <>
          <SectionHeader title="All Albums" />
          <MediaGridView collection={albums} route="album" />
        </>
      ) : view === 'all-singles' && (
        <>
          <SectionHeader title="All Singles" />
          <MediaGridView collection={singles} route="single" />
        </>
      ) }
      <Footer />
    </div>
  );
};

export default ArtistProfile;